import React from "react";
import PropTypes from "prop-types";
import { ApplicantListControls, ApplicantListFilters } from "components/Missions/Applicants";
import { APPLICANT_LIST_SORTING_OPTIONS } from "constants/index";
import { Grid } from "components/Containers";

/**
 * ApplicantViewLayout
 *
 * @param {Boolean} hideFilters
 * @param {Boolean} hideSorts
 * @param {Boolean} hideMemberFilter
 * @param {Boolean} hideAdvancedFilters
 * @param {Object}  selected
 * @param {Object}  displaySelected
 * @param {Object}  filterMetadata
 * @param {Node}    children
 */
const ApplicantViewLayout = ({
  hideFilters,
  hideSorts,
  hideMemberFilter,
  hideAdvancedFilters,
  selected,
  displaySelected,
  filterMetadata,
  children,
  ...props
}) => (
  <Grid>
    {!hideFilters && (
      <Grid.col start={1} end={13}>
        <ApplicantListFilters selected={selected} {...props} />
      </Grid.col>
    )}
    {(!hideSorts || !hideAdvancedFilters || !hideMemberFilter) && (
      <Grid.col start={1} end={13}>
        <ApplicantListControls
          selected={displaySelected}
          hideMemberFilter={hideMemberFilter}
          hideAdvancedFilters={hideAdvancedFilters}
          hideSorts={hideSorts}
          hideSortDirection={displaySelected?.sortKey === APPLICANT_LIST_SORTING_OPTIONS[0]?.value}
          formValues={filterMetadata}
          {...props}
        />
      </Grid.col>
    )}
    {children}
  </Grid>
);

ApplicantViewLayout.propTypes = {
  hideFilters: PropTypes.bool,
  hideSorts: PropTypes.bool,
  hideMemberFilter: PropTypes.bool,
  hideAdvancedFilters: PropTypes.bool,
  selected: PropTypes.object,
  displaySelected: PropTypes.object.isRequired,
  filterMetadata: PropTypes.object,
  children: PropTypes.node,
};

export default ApplicantViewLayout;
